// extracted by mini-css-extract-plugin
export default {"history-list-skeleton":"HistoryListSkeleton_history-list-skeleton__NK1DE"};